/* eslint-disable */
import React from 'react'
import { utils_tool } from '@/tool'
const { Storage } = utils_tool

// 拼接样式
export const watermarkStyle = (item) => {
    let { shape, shapeX, shapeY, customAttribute = '', fontSize, color, opacity } = item
    let sty = {}
    // 默认样式
    let defaultSty = {
        top: shape === 1 ? shapeX : 0,
        left: shape === 1 ? shapeY : 0,
    }
    // 生成编写的css样式
    try {
        sty = new Function('return ' + customAttribute)()
    } catch {
        return {
            ...defaultSty
        }
    }
    sty = {
        ...sty,
        fontSize,
        color,
        opacity
    }
    return {
        ...defaultSty,
        ...sty
    }
}

// 整合水印内容 , obj为对象容器, 不配置时默认获取本地user
export const watermarkContent = (item, _obj) => {
    let { content } = item
    let obj = _obj || Storage.getStorage('user');
    try {
        // 过滤出{}包含的内容
        let reg = /{(.+?)}/g
        let arr = content.match(reg)
        // 将['{id}'] 转为['id']
        let mapArr = arr.map(e => {
            return e.substring(1, e.length - 1)
        })
        // 重新替换渲染内容
        mapArr.map(e => {
            let l = `{${e}}`
            let n = obj[e] || ''
            content = content.replace(l, n)
        })
        // 渲染带有变量的水印信息 方式2,暂不采用
        // content = new Function('obj', 'content', 'return eval("`"+content+"`")')(obj, content)
        return content
    } catch {
        return content
    }
}

// 配置信息
export const watermarkCfg = (item, _obj) => {
    let { shape, shapeX, shapeY, angle = 45 } = item
    // 如果自己设定了取参容器,如果容器没有实体内容不采用
    try {
        _obj = Object.keys(_obj).length ? _obj : false
    } catch {
        _obj = false
    }
    return {
        mode: ['grid', 'position'][shape],
        col: shape === 0 && shapeY ? (12 / shapeY) || 12 : 12, // 栅格12 / 列 = 单个栅格
        size: shape === 0 && shapeX && shapeY ? (shapeX * shapeY) || 1 : 1, // 栅格模式时通过列*行得到总数
        contentStyle: watermarkStyle(item),
        content: watermarkContent(item, _obj),
        rotate: angle, // 旋转角度
        fixed: true, // 目前定位模式默认为指定位置
    }
}